export type AuthUser = {
  sub: string;
  username: string;
  email: string | null;
  nickname: string;
  avatarUrl: string | null;
};

const claimText = (value: unknown): string | null => (
  typeof value === 'string' && value.trim().length > 0 ? value.trim() : null
);

const avatarUrl = (value: unknown): string | null => {
  const text = claimText(value);
  if (!text) return null;
  try {
    const url = new URL(text);
    return url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
};

export const normalizeNickname = (value: string): string => {
  const nickname = value.trim();
  if (!nickname) throw new Error('ニックネームを入力してください');
  if (nickname.length > 100) throw new Error('ニックネームは100文字以内で入力してください');
  return nickname;
};

export const authUserFromClaims = (payload: Record<string, unknown>): AuthUser => {
  const sub = typeof payload.sub === 'string' ? payload.sub : '';
  if (!sub) throw new Error('認証トークンに利用者IDがありません');
  const email = claimText(payload.email);
  const nickname = [email, payload['cognito:username'], sub]
    .map(claimText)
    .find((value): value is string => value !== null) ?? sub;
  return {
    sub,
    username: nickname,
    email,
    nickname,
    avatarUrl: avatarUrl(payload.picture),
  };
};